import { inject, Injectable, signal } from '@angular/core';
import {
  Task, TaskFileResponse, TaskMessageQueue,
  TaskSet, TaskSetResponse,
  TaskSetsListItem, TaskSetsListItemResponse,
  TaskSetsListResponse,
} from '@sbd-account-portal/app/modules/tasksets/tasksets.types';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { environment } from '@sbd-account-portal/app/environments/environment';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { Router } from '@angular/router';
import { OpenItem, OpenItemListResponse } from '@sbd-account-portal/app/modules/dashboard/task-widget/open-item.types';

@Injectable({
  providedIn: 'root',
})
export class TasksetsService {

  private _httpClient = inject(HttpClient);

  taskSets = signal<TaskSetsListItem[]>([]);
  openItems = signal<OpenItem[]>([]);
  dashboardDisplayAllTask = signal<boolean>(false);
  openRightSideDrawer = signal<boolean>(false);
  selectedTaskSetFromTaskSetList = signal<TaskSet>(null);
  selectedQR = signal<OpenQuoteRequestsItem>(null);
  currentMenu = signal<string>('inbox');
  isComposingMessage = signal<boolean>(false);
  newMessage = signal<boolean>(false);
  defaultMessageReceiver = signal<string>('');
  totalTaskSets = signal<number>(0);
  taskSet = signal<TaskSet>(null);
  //will act like a message content holder while switching between menus
  //it existence should trigger the view of "New Message" in menu
  taskMessage = signal<TaskMessageQueue>(null);
  _router = inject(Router);
  showMessageEditor = signal<boolean>(false);
  displayNewMessagePlaceholder = signal<boolean>(false);



  constructor() {
    // this.getTaskSets().subscribe();
  }


  getOpenItems(filters: any = {}): Observable<OpenItem[]> {
    const params = filters || {};
    return this._httpClient
      .get<OpenItemListResponse>(
        `${environment.apiBaseUrl}/v4/tasksets/open-items`, {
          params: params,
        },
      ).pipe(
        map((response) => {
          this.openItems.set(response.data.tasksets.tasksets);
          return response.data.tasksets.tasksets;
        }),
      );
  }

  getTaskSets(filters: any = {}): Observable<TaskSetsListItem[]> {
    const params = filters || {};
    return this._httpClient
      .get<TaskSetsListResponse>(
        `${environment.apiBaseUrl}/v4/tasksets`, {
          params: params,
        },
      ).pipe(
        map((response) => {
          this.taskSets.set(response.data.tasksets.tasksets);
          return response.data.tasksets.tasksets;
        }),
      );
  }

  sendMessage(data: any, refreshTaskSets: boolean = true): Observable<any> {
    return this._httpClient.post<TaskSetResponse>(
      `${environment.apiBaseUrl}/v4/task/send-message`, data,
    ).pipe(
      map((response: TaskSetResponse) => {
        if(response && response?.success) {
          if(refreshTaskSets){
            this.getTaskSets().subscribe((d) => {
              const theTaskSet = response.data.taskset.taskset;
              if(theTaskSet?.task_set_id){
                this.selectedTaskSetFromTaskSetList.set(d.find(t => +t.task_set_id === +theTaskSet.task_set_id));
                this.currentMenu.set('inbox')
              }
            });
          }
        }
        return response;
      }),
    );
  }
  markMessageAsRead(task: Task): Observable<any> {
    return this._httpClient.get<TaskSetsListResponse>(
      `${environment.apiBaseUrl}/v4/task/mark-as-read/${task.task_id}`,
    ).pipe(
      map((response: TaskSetsListResponse) => {
        if(response && response?.success) {
          this.getTaskSets().subscribe((d) => {
            if(task?.task_set_id){
              this.getTaskSet(task.task_set_id).subscribe()
              //this.selectedTaskSetFromTaskSetList.set(d.find(t => +t.task_set_id === +task.task_set_id));
            }
          });
        }
        return response;
      }),
    );
  }

  readFile(task_id: number, file_id: number) {
    return this._httpClient.get<TaskFileResponse>(
      `${environment.apiBaseUrl}/v4/task/${task_id}/read-file/${file_id}`,
    ).pipe(
      map((response: TaskFileResponse) => {
        if (response?.success && response.data?.task?.file?.file_content) {
          const file = response.data.task.file;
          const fileContentBase64 = file.file_content;

          // Decode base64 string
          const byteCharacters = atob(fileContentBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);

          // Create blob and trigger download
          const blob = new Blob([byteArray], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = file.filename;
          a.click();
          window.URL.revokeObjectURL(url);
        }
        return response;
      }),
    );
  }

  getTaskSet(task_set_id: number): Observable<TaskSet> {
    return this._httpClient
      .get<TaskSetsListItemResponse>(
        `${environment.apiBaseUrl}/v4/taskset/${task_set_id}`, {
        },
      ).pipe(
        map((response) => {
          if (response?.success) {
            this.selectedTaskSetFromTaskSetList.set(response.data.taskset.taskset);
            return response.data.taskset.taskset;
          }
          return null;

        }),
      );
  }
}
